import React, {Component} from "react";
import {addDays, dateHelper, formsUpdater, getFormFieldValue} from "../../Applications/shared/shared";
import {Button, Col, FormGroup, FormText, Input, InputGroup, Label, Row} from "reactstrap";
import {getData, postData} from "../../../api/doLogin";
import {InputAdapter, TextMask} from "react-text-mask-hoc";
import {grabFirstLastNames} from "../../../util/stringhelpers";
import {EventClient} from "../../../util/eventClient";
import {toast, ToastContainer} from 'react-toastify';

export class AssignAccessCode extends Component {
  constructor(props) {
    super(props);
    let names = props['input'] ? grabFirstLastNames(props['input']['name']) : {fname: "", lname: ""};
    this.state = {
      dataLoaded: false,
      data: [],
      formData: {
        id: null,
        action: props['edit']['id'] ? "edit" : "add",
        name: names.fname,
        lname: names.lname,
        email: props['input'] ? props['input']['email'] || "" : "",
        expires: dateHelper(addDays(new Date(), 2)),
        applicantID: props['input'] ? props['input']['id'] : 0,
        ...props['edit']
      },
      showIndicator: false
    };
    this.saveAccess.bind(this);
  }

  componentWillMount() {
    EventClient.on('ACCESS_CODE_SAVE', () => this.saveAccess(), "AssignAccessCode");
  }

  componentWillUnmount() {
    EventClient.off('ACCESS_CODE_SAVE', () => this.saveAccess, "AssignAccessCode");
  }

  shouldComponentUpdate(nextProps, nextState) {
    // like writing return true
    return this.state.formData !== nextState.data || this.state.data !== nextState.data;
  }

  generate() {
    var self = this;
    getData("careers/access/generate", {}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          self.setState({formData: {...this.state.formData, code: data.data}});
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  saveAccess() {
    let self = this;
    if (getFormFieldValue(this.state.formData['code']) === "") {
      toast.error("Please Enter Code");
      return;
    }
    if (getFormFieldValue(this.state.formData['name']) === "") {
      toast.error("Please Enter First Name");
      return;
    }
    if (getFormFieldValue(this.state.formData['lname']) === "") {
      toast.error("Please Enter Last Name");
      return;
    }
    if (getFormFieldValue(this.state.formData['email']) === "") {
      toast.error("Please Enter Email");
      return;
    }
    if (getFormFieldValue(this.state.formData['type']) === "") {
      toast.error("Please Select Template");
      return;
    }
    // console.log({...this.state.formData});
    postData("careers/access/save", {...this.state.formData}, this.props.token)
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          toast.success("Saved");
          setTimeout(() => {
            if (self.props.onSave) {
              self.props.onSave();
            }
          }, 1500);
        } else {
          toast.error(data.message);
        }
      })
      .catch(error => {
        console.error(error);
        toast.error("Didn't work");
      });
  }

  selectTemplate(type) {
    console.log("Got here", type);
    if (type.length > 0 && this.props.templates.length > 0) {
      this.props.templates.map((template) => {
        if (template['templateName'] === type) {
          const newFormData = {
            ...this.state.formData,
            type: type,
            premium: template.premium,
            policy: template.policy,
            closerate: template.closerate,
            commission: template.commission,
            advance: template.advance,
            bonus: template.bonus
          };
          console.log("Got here", newFormData);
          this.setState({formData: newFormData}, () => {
            console.log(this.state.formData);
          });
        }
      });

    }
  }

  validate(evt, type) {
    if (evt.target.value.length === 0) return;
    console.log(evt.target.value, type);
    let check;

    function alertMessage(text, field) {
      alert(`Please enter a valid ${text} in ${field}`);
    }

    switch (type) {
      case "dollar":
        check = /^[0-9]+(\.[0-9][0-9])?$/i;
        if (!check.test(evt.target.value)) {
          alertMessage("number", evt.target.id);
          evt.target.value = "";
          formsUpdater(evt, this.state['formData'], this);
          return false;
        }
        break;
      case "email":
        check = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i;
        if (!check.test(evt.target.value)) {
          alertMessage("email", evt.target.id);
          evt.target.value = "";
          formsUpdater(evt, this.state['formData'], this);
          return false;
        }
        break;

      case "percentage":
        check = /^(100|[1-9]?\d{1})$/i;
        if (!check.test(evt.target.value)) {
          alertMessage("number from 0-100", evt.target.id);
          evt.target.value = "";
          formsUpdater(evt, this.state['formData'], this);
          return false;
        }
        break;
      case "datetime":
        check = /^\d\d\d\d-(0?[1-9]|1[0-2])-(0?[1-9]|[12][0-9]|3[01]) (00|[0-9]|1[0-9]|2[0-3]):([0-9]|[0-5][0-9]):([0-9]|[0-5][0-9])$/i;
        if (!check.test(evt.target.value)) {
          alertMessage("date", evt.target.id);
          evt.target.value = "";
          formsUpdater(evt, this.state['formData'], this);
          return false;
        }
        break;
    }
  }

  render() {
    const containerStyle = {
      zIndex: 1999
    };
    return (
      <Row>
        <ToastContainer position="bottom-right" autoClose={1500} style={containerStyle}/>
        <Col xs={6}>
          <Row>
            <Col xs="6">
              <FormGroup>
                <Label for="code">Code</Label>
                <Input
                  placeholder={"Type/Click Generate"}
                  type="text"
                  id="code"
                  value={getFormFieldValue(this.state.formData['code'])}
                  onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                />
              </FormGroup>
            </Col>
            <Col xs="2">
              <Label for="generate">&nbsp;</Label>
              <Button onClick={() => this.generate()}>Generate</Button>
            </Col>
          </Row>
          <Row>
            <Col xs="6">
              <FormGroup>
                <Label for="name">First Name</Label>
                <Input
                  type="text"
                  id="name"
                  value={getFormFieldValue(this.state.formData['name'])}
                  onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                />
              </FormGroup>
            </Col>
            <Col xs="6">
              <FormGroup>
                <Label for="lname">Last Name</Label>
                <Input
                  type="text"
                  id="lname"
                  value={getFormFieldValue(this.state.formData['lname'])}
                  onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs="12">
              <FormGroup>
                <Label for="email">Email</Label>
                <Input
                  type="text"
                  id="email"
                  value={getFormFieldValue(this.state.formData['email'])}
                  onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                  onBlur={(evt) => this.validate(evt, "email")}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs="6">
              <FormGroup>
                <Label for="type">Template</Label>
                <Input type="select" id="type" placeholder=""
                       value={getFormFieldValue(this.state.formData['type'])}
                       onChange={(evt) => this.selectTemplate(evt.target.value)}
                >
                  <option value={""}>Please Select...</option>
                  {(this.props.templates || []).map((val, i) => {
                    return <option key={i} value={val['templateName']}>{val['templateName']}</option>
                  })}
                </Input>
              </FormGroup>
            </Col>
          </Row>
        </Col>

        <Col xs={6}>
          <Row>
            <Col xs="9">
              <FormGroup>
                <Label for="expires">Expires</Label>
                <InputGroup>
                  <div className="input-group-prepend">
                    <span className="input-group-text"><i className="fa fa-calendar"></i></span>
                  </div>
                  <TextMask
                    mask={[/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, ' ', '2', '3', ':', '5', '9', ':', '5', '9']}
                    Component={InputAdapter}
                    className="form-control"
                    id="expires"
                    value={getFormFieldValue(this.state.formData['expires']) ? getFormFieldValue(this.state.formData['expires']) : ""}
                    onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                    onBlur={(evt) => this.validate(evt, "datetime")}
                  />
                </InputGroup>
                <FormText color="muted">
                  ex. YYYY-MM-DD (2019-10-23 at MIDNIGHT)
                </FormText>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs="6">
              <FormGroup>
                <Label for="premium">Premium</Label>
                <InputGroup className="input-prepend">
                  <div className="input-group-prepend">
                    <span className="input-group-text">$</span>
                  </div>
                  <Input
                    type="text"
                    id="premium"
                    value={getFormFieldValue(this.state.formData['premium'])}
                    onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                    onBlur={(evt) => this.validate(evt, "dollar")}
                  />
                </InputGroup>
              </FormGroup>
            </Col>
            <Col xs="6">
              <FormGroup>
                <Label for="policy">Policy</Label>
                <InputGroup className="input-prepend">
                  <div className="input-group-prepend">
                    <span className="input-group-text">$</span>
                  </div>
                  <Input
                    type="text"
                    id="policy"
                    value={getFormFieldValue(this.state.formData['policy'])}
                    onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                    onBlur={(evt) => this.validate(evt, "dollar")}
                  />
                </InputGroup>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs="6">
              <FormGroup>
                <Label for="closerate">Close Rate</Label>
                <InputGroup className="input-prepend">
                  <Input
                    type="text"
                    id="closerate"
                    value={getFormFieldValue(this.state.formData['closerate'])}
                    onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                    style={{textAlign: "right"}}
                    onBlur={(evt) => this.validate(evt, "percentage")}
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">%</span>
                  </div>
                </InputGroup>

              </FormGroup>
            </Col>
            <Col xs="6">
              <FormGroup>
                <Label for="commission">Commission</Label>
                <InputGroup className="input-prepend">
                  <Input
                    type="text"
                    id="commission"
                    value={getFormFieldValue(this.state.formData['commission'])}
                    onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                    style={{textAlign: "right"}}
                    onBlur={(evt) => this.validate(evt, "percentage")}
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">%</span>
                  </div>
                </InputGroup>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs="6">
              <FormGroup>
                <Label for="advance">Advance</Label>
                <InputGroup className="input-prepend">
                  <Input
                    type="text"
                    id="advance"
                    value={getFormFieldValue(this.state.formData['advance'])}
                    onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                    style={{textAlign: "right"}}
                    onBlur={(evt) => this.validate(evt, "percentage")}
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">%</span>
                  </div>
                </InputGroup>
              </FormGroup>
            </Col>
            <Col xs="6">
              <FormGroup>
                <Label for="bonus">Bonus</Label>
                <InputGroup className="input-prepend">
                  <div className="input-group-prepend">
                    <span className="input-group-text">$</span>
                  </div>
                  <Input
                    type="text"
                    id="bonus"
                    value={getFormFieldValue(this.state.formData['bonus'])}
                    onChange={(evt) => formsUpdater(evt, this.state['formData'], this)}
                    onBlur={(evt) => this.validate(evt, "dollar")}
                  />
                </InputGroup>
              </FormGroup>
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/Careers/views/AssignAccessCode.js